import { TypeDefinition } from "../generic";

export class AbstractAuthorRoles {
    public static Primary: TypeDefinition = { id: 1, name: "Primary author" };
    public static CoAuthor: TypeDefinition = { id: 2, name: "Co-author" };

    public static Values: TypeDefinition[] = [
        AbstractAuthorRoles.Primary,
        AbstractAuthorRoles.CoAuthor,
    ];

    public static IDs: number[] = AbstractAuthorRoles.Values.map((v) => v.id);

    public static isPrimary = (r: number | { roleId: number }) => {
        const x = typeof r === "number" ? r : (r ? r.roleId : 0);
        return x === AbstractAuthorRoles.Primary.id;
    }
}



// WEBPACK FOOTER //
// ./src/models/abstract/AbstractAuthorRoles.ts